module.exports = __webpack_public_path__ + "images/industrial-1-47aa55620bc434be1826593444baa85f.jpg";